export { default as rootEpic, epicsList, epic$ } from './epics';
